import QRCode from 'qrcode'

/** Quiet zone in modules, as required by the QR spec for reliable detection. */
export const QUIET_ZONE = 4
/** Desired edge length in CSS px. The real size snaps to whole device px per module. */
export const TARGET_SIZE = 248
/** Module size of the downloaded PNG, so it survives printing and re-scanning. */
const DOWNLOAD_SCALE = 16

export const EC_LEVEL = 'M' as const

export const RENDER_OPTIONS = {
  errorCorrectionLevel: EC_LEVEL,
  margin: QUIET_ZONE,
  color: { dark: '#0f2a2e', light: '#ffffff' }
}

/** Number of modules per side for a given payload, quiet zone excluded. */
export const getModuleCount = (value: string) =>
  QRCode.create(value, { errorCorrectionLevel: EC_LEVEL }).modules.size

/** Download the code as a PNG large enough to stay scannable off paper. */
export const downloadPayBySquareQR = async (value: string, fileName: string) => {
  const url = await QRCode.toDataURL(value, {
    ...RENDER_OPTIONS,
    scale: DOWNLOAD_SCALE
  })
  const link = document.createElement('a')
  link.download = fileName
  link.href = url
  link.click()
}
